<lcs-loading-overlay
  class="flex-dir-col"
  [show]="callState | lcsCallState : 'loading'"
  *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'Location'"
  >
  <div class="detail-page-headerbar">
    <div class="left">
      <div class="page-heading">
        <h2 class="page-title">Location - {{ location?.address }}</h2>
      </div>
    </div>
    <button
      type="button"
      mat-button
      [matMenuTriggerFor]="updateDetailsMenu"
      matTooltip="Info"
      aria-label="Location Info"
      id="extension-detail-info"
      >
      <mat-icon>info</mat-icon>
    </button>
    @if (locationPrivileges.canDelete) {
      <button
        type="button"
        mat-button
        [matMenuTriggerFor]="locationMenu"
        aria-label="Location Actions"
        matTooltip="More Actions"
        id="location-detail-more-actions"
        >
        <mat-icon>more_horiz</mat-icon>
      </button>
    }
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <ndt-two-column-layout>
      <div ndtLeftColumn>
        <div class="details-wrapper">
          @if (location?.name) {
            <h5>Name</h5>
            <div class="detail-item">{{ location.name }}</div>
          }
        </div>
        <div class="details-wrapper">
          @if (location?.address) {
            <h5>Address</h5>
            <div class="detail-item">{{ location.address }}</div>
            <div class="detail-item">{{ location.city }}, {{ location.state }} {{ location.postalCode }} </div
              ><div class="detail-item">{{ location.country }}</div>
            }
          </div>
          <div class="details-wrapper">
            @if (location?.timeZoneId) {
              <h5>Time Zone</h5><div class="detail-item">{{ location.timeZoneId }}</div>
            }
          </div>
          <div class="details-wrapper">
            @if (location?.mostRecentE911ValidationResponse) {
              <h5>E911</h5>
              <div class="detail-item">
                <span>{{ location?.isE911Validated ? '' : 'Not' }} E911 Validated</span>
              </div>
              <h5>Most Recent E911 Validation Response</h5
                ><div class="detail-item">{{ location.mostRecentE911ValidationResponse }}</div>
              }
            </div>
          </div>
          <div ndtRightColumn>
            <mat-tab-group class="detail-tab-group" ndt-tab-router [loadSuccess$]="loadSuccess$">
              <mat-tab [label]="'Location'">
                <div class="mat-tab-indented">
                  <div class="detail-right-column">
                    <ndt-card [title]="'Address'" class="detail-card">
                      <mat-form-field class="flex-half">
                        <mat-label>Name</mat-label>
                        <input
                          matInput
                          autocomplete="off"
                          type="text"
                          [value]="location?.name"
                          formControlName="name"
                          id="name"
                          />
                          @if (form.get('name')?.hasError('maxlength')) {
                            <mat-error
                              >Name must be less than 255 characters</mat-error
                              >
                          }
                          @if (
                            form.get('name')?.hasError('pattern') || form.get('name')?.hasError('noContent')
                            ) {
                            <mat-error
                              >
                              Name must contain characters.
                            </mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="flex-half">
                          <mat-label>House Number</mat-label>
                          <input
                            matInput
                            autocomplete="off"
                            type="text"
                            [value]="location?.houseNumber"
                            formControlName="houseNumber"
                            id="houseNumber"
                            required
                            />
                            @if (form.get('houseNumber')?.hasError('required')) {
                              <mat-error>
                                House Number is Required.
                              </mat-error>
                            }
                            @if (form.get('houseNumber')?.hasError('maxlength')) {
                              <mat-error>
                                House Number limited to 255 characters.
                              </mat-error>
                            }
                          </mat-form-field>
                          <mat-form-field class="flex-half">
                            <mat-label>Street Direction Prefix</mat-label>
                            <input
                              matInput
                              autocomplete="off"
                              type="text"
                              [value]="location?.directionalPrefix"
                              formControlName="directionalPrefix"
                              id="directionalPrefix"
                              />
                              @if (form.get('directionalPrefix')?.hasError('maxlength')) {
                                <mat-error>
                                  Street Direction Prefix limited to 255 characters.
                                </mat-error>
                              }
                            </mat-form-field>
                            <mat-form-field class="flex-full">
                              <mat-label>Street Name</mat-label>
                              <input
                                matInput
                                autocomplete="off"
                                type="text"
                                [value]="location?.streetName"
                                formControlName="streetName"
                                id="streetName"
                                required
                                />
                                @if (form.get('streetName')?.hasError('required')) {
                                  <mat-error>
                                    Street Name is Required. </mat-error
                                    >
                                  }@if (form.get('streetName')?.hasError('maxlength')) {
                                  <mat-error>
                                    Street Name limited to 255 characters.
                                  </mat-error>
                                }
                              </mat-form-field>
                              <mat-form-field class="flex-half">
                                <mat-label>Street Name Suffix</mat-label>
                                <input
                                  matInput
                                  autocomplete="off"
                                  type="text"
                                  [value]="location?.streetNameSuffix"
                                  formControlName="streetNameSuffix"
                                  id="streetNameSuffix"
                                  />
                                  @if (form.get('streetNameSuffix')?.hasError('pattern')) {
                                    <mat-error>
                                      Invalid Street Name Suffix
                                    </mat-error>
                                  }
                                  @if (form.get('streetNameSuffix')?.hasError('maxlength')) {
                                    <mat-error>
                                      Street Name Suffix limited to 255 characters
                                    </mat-error>
                                  }
                                </mat-form-field>
                                <mat-form-field class="flex-half">
                                  <mat-label>Street Direction Suffix</mat-label>
                                  <input
                                    matInput
                                    autocomplete="off"
                                    type="text"
                                    [value]="location?.directionalPostfix"
                                    formControlName="directionalPostfix"
                                    id="directionalPostfix"
                                    />
                                    @if (form.get('directionalPostfix')?.hasError('pattern')) {
                                      <mat-error>
                                        Invalid Street Direction Suffix
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                  <mat-form-field class="flex-full">
                                    <mat-label>City</mat-label>
                                    <input
                                      matInput
                                      autocomplete="off"
                                      type="text"
                                      [value]="location?.city"
                                      formControlName="city"
                                      id="city"
                                      required
                                      />
                                      @if (form.get('city')?.hasError('required')) {
                                        <mat-error> City is Required. </mat-error>
                                      }
                                      @if (form.get('city')?.hasError('maxlength')) {
                                        <mat-error>
                                          City limited to 255 characters.
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                    <mat-form-field class="flex-half">
                                      <mat-label>State</mat-label>
                                      <input
                                        autocomplete="off"
                                        type="text"
                                        formControlName="state"
                                        id="state"
                                        lcsStaticSelect
                                        [lcsSingleSelect]="stateSelect"
                                        [lcsStaticSelectValue]="form.get('state')?.value"
                                        (search)="stateSearch($event)"
                                        (reset)="stateSearchReset()"
                                        (stateChanged)="handleStateChange($event)"
                                        required
                                        />
                                        <lcs-static-select #stateSelect [displayWith]="stateDisplayWith">
                                          @for (state of states; track state) {
                                            <lcs-option [value]="state.abbreviation">
                                              {{ state.name }} - {{ state.abbreviation }}
                                            </lcs-option>
                                          }
                                        </lcs-static-select>
                                        @if (form.get('state')?.hasError('required')) {
                                          <mat-error>
                                            State is Required.
                                          </mat-error>
                                        }
                                        @if (
                                          !form.get('state')?.hasError('required') &&
                                          form.get('state')?.hasError('whitespace')
                                          ) {
                                          <mat-error
                                            >State cannot have whitespace</mat-error
                                            >
                                        }
                                      </mat-form-field>
                                      <mat-form-field class="flex-half">
                                        <mat-label>Postal Code</mat-label>
                                        <input
                                          matInput
                                          autocomplete="off"
                                          type="text"
                                          [value]="location?.postalCode"
                                          formControlName="postalCode"
                                          id="postalCode"
                                          required
                                          />
                                          @if (form.get('postalCode')?.hasError('required')) {
                                            <mat-error>
                                              Postal Code is Required.
                                            </mat-error>
                                          }
                                          @if (
                                            !form.get('postalCode')?.hasError('required') &&
                                            form.get('postalCode')?.hasError('whitespace')
                                            ) {
                                            <mat-error
                                              >
                                              Invalid Postal Code.
                                            </mat-error>
                                          }
                                        </mat-form-field>
                                        <mat-form-field class="flex-half">
                                          <mat-label>Country</mat-label>
                                          <input
                                            autocomplete="off"
                                            type="text"
                                            formControlName="country"
                                            id="country"
                                            lcsStaticSelect
                                            [lcsSingleSelect]="countrySelect"
                                            [lcsStaticSelectValue]="form.get('country')?.value"
                                            (search)="countrySearch($event)"
                                            (reset)="countrySearchReset()"
                                            />
                                            <lcs-static-select
                                              #countrySelect
                                              [displayWith]="countryDisplayWith"
                                              [trackBy]="countryTrackBy"
                                              >
                                              @for (country of countries; track country) {
                                                <lcs-option [value]="country">
                                                  {{ country }}
                                                </lcs-option>
                                              }
                                            </lcs-static-select>
                                          </mat-form-field>
                                          <mat-form-field class="flex-half">
                                            <mat-label>Time Zone</mat-label>
                                            <input
                                              class="empty-option-placeholder"
                                              [lcsSingleSelect]="timeZoneSelect"
                                              ndtTimeZoneSelect
                                              autocomplete="off"
                                              type="text"
                                              formControlName="timeZone"
                                              id="timeZone"
                                              [placeholder]="'Use Account Time Zone - (' + location?.account?.timeZoneId + ')'"
                                              required
                                              />
                                              <ndt-time-zone-select
                                                #timeZoneSelect
                                                [isIncludeEmptyOption]="true"
                                 [overrideEmptyOption]="
                                    'Use Account Time Zone - (' + location?.account?.timeZoneId + ')'
                                 "
                                              ></ndt-time-zone-select>
                                              @if (form.get('timeZone')?.hasError('required')) {
                                                <mat-error>
                                                  Time Zone Field is Required.
                                                </mat-error>
                                              }
                                            </mat-form-field>
                                          </ndt-card>

                                          <ndt-card [title]="'Other Information'" class="detail-card">
                                            <mat-form-field class="flex-half">
                                              <mat-label>Comment</mat-label>
                                              <input
                                                matInput
                                                autocomplete="off"
                                                type="text"
                                                [value]="location?.comment"
                                                formControlName="comment"
                                                id="comment"
                                                />
                                                @if (form.get('comment')?.hasError('maxlength')) {
                                                  <mat-error>
                                                    Comment field limited to 50 characters.
                                                  </mat-error>
                                                }
                                              </mat-form-field>
                                            </ndt-card>
                                          </div>
                                        </div>
                                      </mat-tab>
                                      <mat-tab [label]="'Extensions'">
                                        @if (location?.locationId) {
                                          <ndt-location-extension-register
                                            [locationId]="location?.locationId"
                                          ></ndt-location-extension-register>
                                        }
                                      </mat-tab>
                                      <mat-tab [label]="'Phone Numbers'">
                                        <ng-container>
                                          @if (location?.locationId) {
                                            <ndt-location-phone-number-register
                                              [locationId]="location?.locationId"
                                            ></ndt-location-phone-number-register>
                                          }
                                        </ng-container>
                                      </mat-tab>
                                    </mat-tab-group>
                                  </div>
                                </ndt-two-column-layout>
                                <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
                              </form>
                            </lcs-loading-overlay>
                            <mat-menu #locationMenu="matMenu">
                              @if (locationPrivileges.canDelete) {
                                <button
                                  mat-menu-item
                                  type="button"
                                  (click)="onDeleteClick()"
                                  id="menu-location-delete"
                                  >
                                  Delete
                                </button>
                              }
                            </mat-menu>
                            <mat-menu #updateDetailsMenu="matMenu">
                              <update-details
                                [createUser]="location?.createUser"
                                [createDate]="location?.createDate"
                                [updateUser]="location?.updateUser"
                                [updateDate]="location?.updateDate"
                              ></update-details>
                            </mat-menu>
